(function() {
	'use strict';

	angular
		.module('humbertContainer')
		.controller('ContainerFormController', ContainerFormController);

	ContainerFormController.$inject = ['$state','ContainerService'];

	/* @ngInject */
	function ContainerFormController($state,ContainerService) {
		var vm = this;
		vm.title = 'ContainerFormController';

		vm.fractions = {};
		vm.fractionKey = null;

		vm.containerTypes = {};
		vm.containerTypeKey = null;

		vm.to = null;

		vm.freightZones = {};
		vm.freightZoneKey = null;

		vm.extendedFractionDisplayName = function(fractionKey,fraction) {
			return fractionKey + ' | ' + fraction.displayName + ' ' + fraction.suffix;
		};

		vm.reset = function() {
			vm.fractionKey = null;
			vm.containerTypeKey = null;
			vm.to = null;
			vm.freightZoneKey = null;
			vm.containerForm.$setPristine();
			vm.containerForm.$setUntouched();
		};

		vm.submit = function() {
			$state.go('calc', {
				fractionKey: vm.fractionKey,
				containerTypeKey: vm.containerTypeKey,
				to: (angular.isNumber(vm.to)? vm.to.toString(): ''),
				freightZoneKey: vm.freightZoneKey
			});
		};

		activate();

		////////////////

		function activate() {
			getData();
		}

		function getData() {
			ContainerService.get().then(function(data) {
				vm.fractions = data.fractions;
				vm.containerTypes = data.containerTypes;
				vm.freightZones = data.freightZones;
			});
		}
	}
})();